import sharedLabel from '../../translation'
import type {ILabel} from '../../../../types'

export default {
    ...sharedLabel,
    
    gender: <ILabel>{
        de: 'Anrede',
        en: 'Gender',
        es: 'Título',
        fr: 'Civilité',
        nl: 'Geslacht',
        it: 'Genere',
    },
    title: <ILabel>{
        de: 'Titel',
        en: 'Title',
        es: 'Titulo',
        fr: 'Titre',
        nl: 'Titel',
        it: 'Titolo',
    },
    firstName: <ILabel>{
        de: 'Vorname',
        en: 'Firstname',
        es: 'Nombre',
        fr: 'Prénom',
        nl: 'Voornaam',
        it: 'Nome',
    },
    lastName: <ILabel>{
        de: 'Nachname',
        en: 'Lastname',
        es: 'Apellidos',
        fr: 'Nom',
        nl: 'Achternaam',
        it: 'Cognome',
    },
    street: <ILabel>{
        de: 'Straße',
        en: 'Street',
        es: 'Calle',
        fr: 'Rue',
        nl: 'Straat',
        it: 'Via',
    },
    postalCode: <ILabel>{
        de: 'Postleitzahl',
        en: 'Postcode',
        es: 'Código postal',
        fr: 'Code postal',
        nl: 'Postcode',
        it: 'CAP',
    },
    city: <ILabel>{
        de: 'Stadt',
        en: 'City',
        es: 'Ciudad',
        fr: 'Ville',
        nl: 'Stad',
        it: 'Cittá',
    },
    country: <ILabel>{
        de: 'Land',
        en: 'Country',
        es: 'País',
        fr: 'Pays',
        nl: 'Land',
        it: 'Paese',
    },
    confirmPassword: <ILabel>{
        de: 'Passwort bestätigen',
        en: 'Confirm Password',
        es: 'Confirma Contraseña',
        fr: 'Confirmer le mot de passe',
        nl: 'Bevestig wachtwoord',
        it: 'Conferma Password',
    },
    
    // form success notification
    
    registerSuccessTitle: <ILabel>{
        de: 'Willkommen bei Juwelo!',
        en: 'Welcome to Juwelo!',
        es: '¡Bienvenido a Juwelo!',
        fr: 'Bienvenue sur Juwelo !',
        nl: 'Welkom bij Juwelo!',
        it: 'Benvenuto su Juwelo!',
    }, 
    registerSuccessText: <ILabel>{
        de: 'Sie sind nun registriert und angemeldet. Jetzt benötigen wir nur noch wenige Angaben für die Liveshows und schon kann es los gehen.',
        en: 'You are now registered and logged in. All we need is some information for the live tv shows and we\'re off.',
        es: 'Ya está registrado y ha iniciado sesión. Ahora sólo faltan algunos detalles para la live tv shows en vivo y podrá empezar.',
        fr: 'Vous êtes maintenant inscrit et connecté. Il ne nous manque plus que quelques informations pour la vente en direct et c\'est parti.',
        nl: 'U bent nu geregistreerd en ingelogd. Nu hebben we alleen nog een paar details nodig voor de live shows en u bent klaar om te gaan.',
        it: 'Ora sei registrato e loggato. Abbiamo solo bisogno di alcuni dettagli per l\'acquisto in diretta e poi sarai pronto a partire.',
    },
    
    dataPrivacyAppliesHtml: <ILabel>{
        de: 'Bitte beachten Sie unsere <a href="/datenschutz/">Datenschutzhinweise</a>.',
        en: 'Please take note of our <a href="/privacy-policy/">data protection information</a>.',
        es: 'Tenga en cuenta nuestra <a href="/politica-privacidad/">política de privacidad</a>.',
        fr: 'Veuillez prendre connaissance de nos <a href="/service-clients/protection-des-donnees/">informations sur la protection des données</a>.',
        nl: 'Gelieve kennis te nemen van ons <a href="/klantenservice/privacybeleid/">privacybeleid</a>.',
        it: 'Si prega di notare la nostra <a href="/privacy/">politica sulla privacy</a>.',
    },
    
    invalidEmailAddress: <ILabel>{
        de: 'Ungültige E-Mail-Adresse, bitte überprüfen.',
        en: 'Invalid e-mail address, please check.',
        es: 'Dirección de correo electrónico no válido, por favor, verifique si es correcto.',
        fr: 'Adresse e-mail non valide, veuillez vérifier.',
        nl: 'Ongeldig e-mail adres, gelieve te controleren.',
        it: 'Indirizzo email non valido, si prega di controllare.',
    },
    invalidEmailAlreadyInUse: <ILabel>{
        de: 'E-Mail-Adresse ist bereits vergeben.',
        en: 'The e-mail address is already in use.',
        es: 'La dirección de correo electrónico ya existe.',
        fr: 'L\'adresse e-mail est déjà utilisée.',
        nl: 'E-mail adres is al in gebruik.',
        it: 'L\'indirizzo email è già stato utilizzato.',
    },
    invalidPasswordTooShort: <ILabel>{
        de: 'Bitte geben Sie 6 oder mehr Zeichen ein.',
        en: 'Please enter 6 or more characters.',
        es: 'Por favor introduzca 6 o más caracteres.',
        fr: 'Veuillez saisir 6 caractères ou plus.',
        nl: 'Voer 6 of meer tekens in.',
        it: 'Si prega di inserire 6 o più caratteri.',
    },
    invalidPasswordConfirmationNotEqual: <ILabel>{
        de: 'Bitte stellen Sie sicher, dass Ihre Passwörter übereinstimmen.',
        en: 'Please make sure your passwords match.',
        es: 'Por favor asegúrese de que sus contraseñas coincidan.',
        fr: 'Veuillez vous assurer que vos mots de passe correspondent.',
        nl: 'Zorg ervoor dat uw wachtwoorden overeenkomen.',
        it: 'Assicurati che le tue password corrispondano.',
    },
}